import { hexToRgb, getLuminance, safe } from '../utils/contrast.js';
import { estiloDeBoton } from '../utils/boton-estilo.js';
import { store } from '../core/store.js';
import { t } from '../utils/i18n.js';
import { ctaAnchorAttrs, hrefSeguro } from '../utils/links.js';
import { escapeHtml } from '../utils/dom.js';
import { iconSvg } from '../utils/icons.js';
import { alturaLogo, estiloLogo } from '../utils/logo-header.js';
import { limpiar } from '../utils/titulo-pestana.js';

    export const headerBlock = (rawProps) => {
        const p = safe(rawProps);   // `logo` lo coalesce safe(); el apaño de aquí no servía (ver contrast.js)
        const isEditor = store.get('editorMode');
        // Tamaño A MANO del logo (asa del editor, editor/logo-tamano.js). Sin prop = como siempre.
        const altoLogo = alturaLogo(p.logo_height);

        // Contenedor principal
        let containerClass = p.variant === 'v3' ? "nav-pro pill" : "nav-pro";
        // `color: var(--text)` va inline en el <header> para que el color del logo y
        // los nav-links sobreviva al "header hoist" de preview/publicado (render.js
        // mueve el <header> FUERA de #resultado, donde la regla CSS `#resultado header`
        // ya no aplica y el texto caería al color oscuro del body de base_builder.html).
        let baseStyles = `--bg:${p.bgColor}; --text:${p.textColor}; --accent:${p.accentColor}; --font:'${p.fontFamily || "Inter"}'; --accent-contrast:${p.accentContrast}; color: var(--text); background: color-mix(in srgb, var(--bg) 93%, transparent); position: relative; z-index: 100;`;

        if (p.variant === 'v3') {
            baseStyles = `--bg:${p.bgColor}; --text:${p.textColor}; --accent:${p.accentColor}; --font:'${p.fontFamily || "Inter"}'; --accent-contrast:${p.accentContrast}; color: var(--text); background: color-mix(in srgb, var(--bg) 80%, transparent); width: 90%; max-width: 1200px; border: 1px solid color-mix(in srgb, var(--text) 13%, transparent); box-shadow: 0 10px 40px rgba(0,0,0,0.15); z-index: 999;`;
        }

        // LÓGICA DE VARIANTES (v1: Nav Derecha, v2/v3: Nav Centro)
        const isCentered = p.variant === 'v2' || p.variant === 'v3';

        return `
      <header class="${containerClass}" style="${baseStyles}">
        
        <style>
          .nav-wrapper {
             display: flex; flex: 2; justify-content: ${isCentered ? 'center' : 'flex-end'}; padding: 0 20px;
             overflow: hidden;
          }
          .nav-links-container {
            display: flex; gap: 25px; align-items: center; overflow-x: auto; 
            scrollbar-width: none; -ms-overflow-style: none; padding: 5px 10px;
            mask-image: linear-gradient(to right, transparent, black 2%, black 98%, transparent);
            -webkit-mask-image: linear-gradient(to right, transparent, black 2%, black 98%, transparent);
          }
          .nav-links-container::-webkit-scrollbar { display: none; }
          .menu-toggle { display: none; background: none; border: none; color: inherit; line-height: 0; cursor: pointer; padding: 5px; }
          .header-cta-wrapper { flex: ${isCentered ? '1' : '0'}; display: flex; justify-content: flex-end; }

          @container (max-width: 900px) {
            .nav-wrapper { position: static; flex: 0; padding: 0; }
            .nav-links-container {
              display: none; position: absolute; top: 100%; left: 0; width: 100%; 
              background: var(--bg); flex-direction: column; padding: 25px 20px; 
              box-shadow: 0 20px 40px rgba(0,0,0,0.15); border-top: 1px solid color-mix(in srgb, var(--text) 13%, transparent);
              mask-image: none; -webkit-mask-image: none;
            }
            .nav-links-container.open { display: flex !important; }
            .menu-toggle { display: block; margin-left: auto; }
            .header-cta-wrapper { display: none; }
            /* El CTA no puede desaparecer en móvil: .header-cta-wrapper se oculta y
               NO está dentro del desplegable, así que el nav pinta su espejo
               (.header-cta-mobile). Las otras dos superficies (media query real del
               publicado y simulador móvil del editor) lo reafirman en site.css. */
            .header-cta-mobile { display: inline-flex !important; }
          }
        </style>

        <div class="logo-wrapper" style="flex: ${isCentered ? '1' : '0'}; display:flex; align-items:center;">
            ${/* La caja envuelve SOLO la imagen: el asa del tamaño (editor-only, se va al publicar) se
                  coloca contra su esquina. `logo-a-mano` = el cliente fijó el alto → site.css lo topa
                  en móvil (sin prop no se toca: los sitios ya guardados se ven igual). El `alt` es el
                  nombre en TEXTO PLANO (`limpiar`, la misma limpieza que el título de la pestaña): el
                  `logo` se guarda como innerHTML y el alt publicaba `<span style=…>` (museo, 25-09). */''}
            ${p.logo_image_url ? `<span class="logo-caja" style="position: relative; display: inline-flex; margin-right: 12px;"><img src="${p.logo_image_url}" alt="${escapeHtml(limpiar(p.logo || '') || 'Logo')}" draggable="false"${altoLogo != null ? ' class="logo-a-mano"' : ''} style="${estiloLogo(altoLogo)}">${isEditor ? '<span class="logo-asa n3i-asa-caja editor-only" title="Arrastra para cambiar el tamaño del logo" aria-hidden="true"></span>' : ''}</span>` : ''}
            <div data-field="logo" class="logo" contenteditable="true" style="font-weight:900; font-size:1.6rem; letter-spacing:-1px; white-space: nowrap; line-height: 1;">${p.logo}</div>
        </div>
        
        <button class="menu-toggle" type="button" aria-label="${escapeHtml(t('menu_open'))}">${iconSvg('menu', 26)}</button>

        <div class="nav-wrapper">
            <nav class="nav-links-container">
              ${/* ESPEJO del CTA para el menú desplegable (móvil). Detalles que NO se
                    pueden tocar:
                      · sin data-field ni contenteditable → el extractor lee `cta` con
                        querySelector('[data-field="cta"]') (PRIMERA coincidencia) y este
                        nodo va ANTES en el DOM: si lo llevara, el texto del botón se
                        leería de aquí y habría dos copias editables del mismo prop.
                      · sin la clase .editable-link → el handler `header` del extractor
                        recoge por esa clase y lo persistiría como un enlace de nav.
                      · el href sale de ctaAnchorAttrs (embudo único de todo CTA): el
                        destino global se resuelve en cada render y JAMÁS se hornea en
                        data-link (gotcha nº20). Aquí además se pide sin data-link
                        (editable:false) para no duplicar el enlace propio del bloque. */''}
              <a ${ctaAnchorAttrs(p.cta_url, { editable: false })} class="btn-action header-cta-mobile"
                 style="${estiloDeBoton(p, 'cta')}padding: calc(12px * var(--n3b-k, 1)) calc(24px * var(--n3b-k, 1)); font-size: calc(0.9rem * var(--n3b-k, 1)); white-space: nowrap; align-self: stretch; justify-content: center; text-align: center;">${p.cta || t('header_cta')}</a>
              ${p.links.map((l, i) => {
                // Saneo igual que el pie (footer.js) — MISMA SSOT (utils/links.js + dom.js): `url` por
                // hrefSeguro (allowlist de esquema; corta javascript:/data: y el breakout de atributo) y
                // `text` por escapeHtml (el cliente lo edita inline y puede venir de un clonado de web,
                // sin sanitizer en el editor → sin escapar inyectaría markup). El extractor lo lee con
                // textContent (paridad plano↔plano), por eso aquí el texto es plano escapado.
                const linkHtml = `
                <a href="${hrefSeguro(l.url)}" data-link="${hrefSeguro(l.url)}" contenteditable="true" class="editable-link"
                   style="color:inherit; text-decoration:none; font-weight:600; font-size: 1.1rem; opacity:0.8; transition:0.3s; white-space: nowrap; flex-shrink: 0; --link-i: ${i};">
                   ${escapeHtml(l.text || l)}
                </a>`;
                if (isEditor) {
                  return `
                  <div class="nav-link-wrapper" style="position: relative; display: inline-flex; align-items: center;">
                    ${linkHtml}
                    <button class="nav-link-delete-btn editor-only" data-index="${i}" title="Eliminar enlace" type="button">
                      <svg viewBox="0 0 24 24" width="8" height="8" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </button>
                  </div>`;
                }
                return linkHtml;
              }).join('')}
            </nav>
        </div>

        <div class="header-cta-wrapper" style="margin-left: ${isCentered ? '0' : '25px'};">
            <a ${ctaAnchorAttrs(p.cta_url)} class="btn-action" data-field="cta" contenteditable="true"
                    style="${estiloDeBoton(p, 'cta')}padding: calc(12px * var(--n3b-k, 1)) calc(24px * var(--n3b-k, 1)); font-size: calc(0.9rem * var(--n3b-k, 1)); white-space: nowrap;">
                    ${p.cta || t('header_cta')}
            </a>
        </div>
      </header>`;
    }
